import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from '../hd-content-language.service';
import { HdIncarnationCross } from '../basic-properties/hd-chart-properties.types';
import { buildHdCrossKey } from '../basic-properties/hd-incarnation-cross-names';

const HD_CROSSES_ASSET_BASE = '/assets/docs/human-design/crosses';
const HD_CROSS_MARKDOWN_LANGUAGES = new Set(['nl', 'en']);

/**
 * URL-builder voor de markdown-documenten van het incarnatiekruis-info-paneel:
 * een `general`-document en één document per kruis onder
 * `docs/human-design/crosses/{nl,en}/{angle}/{pSun-pEarth-dSun-dEarth}.md`.
 * Juxtapositie en linker hoek delen dezelfde vier poorten, vandaar de hoek als
 * map. Spiegelt {@link HdProfileInfoService}.
 */
@Injectable({ providedIn: 'root' })
export class HdIncarnationCrossInfoService {
  private readonly contentLanguage = inject(HdContentLanguageService);

  generalMarkdownUrl(lang?: string): string {
    return `${HD_CROSSES_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/general.md`;
  }

  crossMarkdownUrl(cross: Pick<HdIncarnationCross, 'gates' | 'angleKey'>, lang?: string): string {
    const [pSun, pEarth, dSun, dEarth] = cross.gates;
    const key = buildHdCrossKey(pSun, pEarth, dSun, dEarth);
    return `${HD_CROSSES_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/${cross.angleKey}/${key}.md`;
  }

  private resolveMarkdownLanguage(lang?: string): string {
    const requestedLanguage = lang ?? this.contentLanguage.effectiveLang();
    const normalizedLanguage = (requestedLanguage || '').toLowerCase().split('-')[0];
    return HD_CROSS_MARKDOWN_LANGUAGES.has(normalizedLanguage) ? normalizedLanguage : 'nl';
  }
}
